export default {
    // * * Move crm permission to this file
    CRM_OPPORTUNITY_WRITE: 'crm.opportunity:write',
};
